/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";

export const getauth = (state) => state.auth;

export const getUid = (state) => state.auth.userId;
export const getLoggedInState = (state) => state.auth.isLoggedIn;
export const getToken = (state) => state.auth.token;
export const getCardData = (state) => state.auth.cardData;
export const getSuccessResponse = (state) => state.auth.successResponse;
export const getAuthApiLoadingStatus = createSelector([getauth], (auth) => ({
  loading: auth && auth.loadingApi ? auth.loadingApi : false,
  loaded: auth && auth.loadedApi ? auth.loadedApi : false,
}));
export const getUserResendingPassSuccessResponse = createSelector(
  [getauth],
  (auth) => (auth && auth.forgot_response ? auth.forgot_response : undefined),
);
export const getForgetPassErrorResponse = createSelector([getauth], (auth) =>
  auth && auth.error ? auth.error : undefined,
);

export const getRefreshHelpSiteSuccessMsg = createSelector([getauth], (auth) =>
  auth && auth.refreshHelpSiteSuccessMsg
    ? auth.refreshHelpSiteSuccessMsg
    : undefined,
);

export const getRefreshHelpSiteErrorMsg = createSelector([getauth], (auth) =>
  auth && auth.refreshHelpSiteErrorMsg
    ? auth.refreshHelpSiteErrorMsg
    : undefined,
);

export const getCheckSSOEligibilitySuccessResponse = createSelector(
  [getauth],
  (auth) => (auth?.ssoDetails ? auth.ssoDetails : undefined),
);

export const getSSOCallbackLoadingStatus = createSelector(
  [getauth],
  (auth) => auth && auth.isLoading,
);
